export const LOFT_IMAGE_LIST_PRESET = [
  {
    displayedName: 'Строгий дизайн ванной комнаты',
    mediaMainPhoto: ['1.jpg/1.jpg', '2.jpg/2.jpg', '3.jpg/3.jpg', '4.jpg/4.jpg'],
    productName: 'strogiy-dizayn-vannoy-komnaty',
    style: 'loft',
  },
  {
    displayedName: 'Туалетная комната в стиле лофт',
    mediaMainPhoto: ['1.jpg/1.jpg', '2.jpg/2.jpg', '3.jpg/3.jpg'],
    productName: 'tualetnaya-komnata-v-stile-loft',
    style: 'loft',
  },
  {
    displayedName: 'Ванная комната в сером мраморе',
    mediaMainPhoto: ['1.jpg/1.jpg', '2.jpg/2.jpg', '3.jpg/3.jpg', '4.jpg/4.jpg'],
    productName: 'vannaya-komnata-v-serom-mramore',
    style: 'loft',
  },
  {
    displayedName: 'Мраморная ванная комната в тёмных оттенках',
    mediaMainPhoto: ['1.jpg/1.jpg', '2.jpg/2.jpg', '3.jpg/3.jpg', '4.jpg/4.jpg'],
    productName: 'mramornaya-vannaya-komnata-v-temnyh-ottenkah',
    style: 'loft',
  },
  {
    displayedName: 'Чёрная ванная комната',
    mediaMainPhoto: ['1.jpg/1.jpg', '2.jpg/2.jpg', '3.jpg/3.jpg', '4.jpg/4.jpg', '5.jpg/5.jpg', '6.jpg/6.jpg'],
    productName: 'chernaya-vannaya-komnata',
    style: 'loft',
  },
  {
    displayedName: 'Маленькая ванная комната стиле лофт',
    mediaMainPhoto: ['1.jpg/1.jpg', '2.jpg/2.jpg', '3.jpg/3.jpg', '4.jpg/4.jpg', '5.jpg/5.jpg', '6.jpg/6.jpg'],
    productName: 'malenkaya-vannaya-komnata-stile-loft',
    style: 'loft',
  },
  {
    displayedName: 'Строгая ванная комната в стиле лофт',
    mediaMainPhoto: ['1.jpg/1.jpg', '2.jpg/2.jpg', '3.jpg/3.jpg', '4.jpg/4.jpg'],
    productName: 'strogaya-vannaya-komnata-v-stile-loft',
    style: 'loft',
  },
  {
    displayedName: 'Ванная в стиле лофт',
    mediaMainPhoto: ['1.jpg/1.jpg', '2.jpg/2.jpg', '3.jpg/3.jpg', '4.jpg/4.jpg'],
    productName: 'vannaya-v-stile-loft',
    style: 'loft',
  },
  {
    displayedName: 'Ванная комната в серо-коричневых оттенках',
    mediaMainPhoto: ['1.jpg/1.jpg', '2.jpg/2.jpg', '3.jpg/3.jpg', '4.jpg/4.jpg', '5.jpg/5.jpg'],
    productName: 'vannaya-komnata-v-sero-korichnevyh-ottenkah',
    style: 'loft',
  },
  {
    displayedName: 'Миниатюрная ванная комната в стиле лофт',
    mediaMainPhoto: ['1.jpg/1.jpg', '2.jpg/2.jpg', '3.jpg/3.jpg'],
    productName: 'miniatyurnaya-vannaya-komnata-v-stile-loft',
    style: 'loft',
  },
  {
    displayedName: 'Компактная ванная комната в стиле лофт',
    mediaMainPhoto: ['1.jpg/1.jpg', '2.jpg/2.jpg', '3.jpg/3.jpg', '4.jpg/4.jpg'],
    productName: 'kompaktnaya-vannaya-komnata-v-stile-loft',
    style: 'loft',
  },
  {
    displayedName: 'Стиль лофт в ванной комнате с душевой перегородкой',
    mediaMainPhoto: ['1.jpg/1.jpg'],
    productName: 'stil-loft-v-vannoy-komnate-s-dushevoy-peregorodkoy',
    style: 'loft',
  },
  {
    displayedName: 'Стиль минимализм-индастриал в ванной комнате',
    mediaMainPhoto: ['1.jpg/1.jpg'],
    productName: 'stil-minimalizm-indastrial-v-vannoy-komnate',
    style: 'loft',
  },
  {
    displayedName: 'Универсальная ванная комната в темных оттенках',
    mediaMainPhoto: ['1.jpg/1.jpg'],
    productName: 'universalnaya-vannaya-komnata-v-temnyh-ottenkah',
    style: 'loft',
  },
];
